// extracted by mini-css-extract-plugin
export var aside = "Aside-module--aside--0a77b";
export var asideNoRule = "Aside-module--asideNoRule--070a8";
export var cdsAssistiveText = "Aside-module--cds--assistive-text--5a066";
export var cdsHideFeedback = "Aside-module--cds--hide-feedback--f6254";
export var cdsShowFeedback = "Aside-module--cds--show-feedback--bd34b";
export var cdsSkeleton = "Aside-module--cds--skeleton--d93ae";
export var cdsVisuallyHidden = "Aside-module--cds--visually-hidden--53185";